<template>
  <v-app>
    <div class="loan_wrapper" v-if="editedItem">
      <div class="page page1">
        <div class="loan_header">
          <h1>和潤企業車輛分期付款申請書</h1>
        </div>
        <!--header-->
        <div class="top">
          <div class="top-nb">
            合約編號：<span>{{ editedItem.displayId }}</span>
          </div>
          <div class="top-date">
            申請日期：<span class="y">{{ editedItem.applyDate.year }}</span
            >年<span class="m">{{ editedItem.applyDate.month }}</span
            >月<span class="d">{{ editedItem.applyDate.day }}</span
            >日
          </div>
          <div class="top-ps">
            原申請條件如下：(核准與否與實際貸款條件，以本公司最終核決結果為準)
          </div>
        </div>
        <!--top-->
        <div class="area1">
          <table class="table1">
            <thead>
              <tr>
                <th colspan="4">
                  申貸產品
                  <div class="con1">
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project0"/></span
                    >本牌新車
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project1"/></span
                    >他牌新車
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project2"/></span
                    >中古車
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project3"/></span
                    >原融
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project4"/></span
                    >借新還舊
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project5"/></span
                    >他行代償
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.project6"/></span
                    >機車
                  </div>
                </th>
                <th width="177px" class="th1 thEnd">*本牌新車需額外填寫</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="157px">
                  <span class="tdTit tdTit1">*經銷商：</span>
                  <div class="con2-1"></div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit2">*營業所：</span>
                  <div class="con3-1"></div>
                </td>
                <td width="147px">
                  <span class="tdTit tdTit3">*車商業代：</span>
                  <div class="con4-1"></div>
                </td>
                <td colspan="2" class="tdEnd">
                  <span class="tdTit tdTit4">*專案名稱：</span>
                  <div class="con5">
                    <span class="checkbox"
                      ><input type="checkbox" disabled v-model="editedItem.laonhfcInfo.zeroRate"/></span
                    >零利率
                    <span class="checkbox" v-model="editedItem.laonhfcInfo.otherProject"
                      ><input type="checkbox" disabled
                    /></span>
                    <div class="con5-1">
                      {{ editedItem.laonhfcInfo.projectName }}
                    </div>
                    <span class="txt">專案</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit5">廠牌：</span>
                  <div class="con6-1">{{editedItem.laonhfcInfo.vendor}}</div>
                </td>
                <td>
                  <span class="tdTit tdTit6">車名：</span>
                  <div class="con7-1">{{editedItem.laonhfcInfo.name}}</div>
                </td>
                <td>
                  <span class="tdTit tdTit7">出廠年月：</span>
                  <div class="con8">
                    <span class="con8-1">{{editedItem.laonhfcInfo.publicYear}}</span>年<span class="con8-1"
                      >{{editedItem.laonhfcInfo.publicMonth}}</span
                    >月
                  </div>
                </td>
                <td>
                  <span class="tdTit tdTit8">車號：</span>
                  <div class="con9-1">{{editedItem.laonhfcInfo.carId}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit9">*折讓前車價：NT</span>
                  <div class="con10">
                    <span class="con10-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit10">*買賣價：NT</span>
                  <div class="con11">
                    <span class="con11-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td>
                  <span class="tdTit tdTit11">參考價：NT</span>
                  <div class="con12">
                    <span class="con12-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td colspan="2">
                  <span class="tdTit tdTit12">參考來源：</span>
                  <div class="con13">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >HOT
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >權威
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >天書
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >其他
                    <div class="con13-1"></div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit13">承辦人：</span>
                  <div class="con14"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table1-->
          <table class="table2">
            <tbody>
              <tr>
                <td width="157px">
                  <span class="tdTit tdTit14">貸款金額：NT</span>
                  <div class="con15">
                    <span class="con15-1">{{editedItem.vendor.totalPrice}}</span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit15">貸款期數：</span>
                  <div class="con16">
                    <span class="con16-1">{{editedItem.vendor.installmentsNumber}}</span>
                    <span class="txt">期</span>
                  </div>
                </td>
                <td width="147px">
                  <span class="tdTit tdTit16">期付款：NT</span>
                  <div class="con17">
                    <span class="con17-1">{{editedItem.vendor.creditPriceMonth}}</span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td width="140px">
                  <span class="tdTit tdTit17">利率：</span>
                  <div class="con18">
                    <span class="con18-1"></span>
                    <span class="txt">%</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit18">*補貼款：NT</span>
                  <div class="con19">
                    <span class="con19-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table2-->
        </div>
        <!--area1-->
        <div class="area2">
          <table class="table3">
            <thead>
              <tr>
                <th>公司戶</th>
              </tr>
            </thead>
          </table>
          <!--table3-->
          <table class="table4">
            <tbody>
              <tr>
                <td width="373px">
                  <span class="tdTit tdTit19">公司名稱：</span>
                  <div class="con20">
                    <span class="con20-1"
                      ></span
                    >
                  </div>
                  <div class="con21">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >有限公司<br />
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >股份有限公司
                  </div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit20">統一編號：</span>
                  <div class="con22">{{editedItem.company.companyId}}</div>
                </td>
                <td width="120px">
                  <span class="tdTit tdTit21">設立日期：</span>
                  <div class="con23">
                    <span class="y"></span>年<span class="m"></span>月
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit22">資本額:NT</span>
                  <div class="con24">
                    <span class="con24-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table4-->
          <table class="table5">
            <tbody>
              <td width="490px">
                <span class="tdTit tdTit23">公司地址：</span>
                <div class="con25">
                  <span class="con25-1"></span>
                  <span class="con25-1"></span>
                  <span class="con25-1"></span>
                </div>
                <div class="con26">
                  <!-- <span class="con26-city">基隆</span>
                  <span class="city-1">縣</span>
                  <span class="city-2 choose">市</span>
                  <span class="con26-area">安樂安樂</span>
                  <span class="area-1">鄉</span>
                  <span class="area-2">鎮</span>
                  <span class="area-3">市</span>
                  <span class="area-4 choose">區</span>
                  <span class="con26-address"
                    >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                  > -->
                </div>
              </td>
              <td width="159px">
                <span class="tdTit tdTit24">電話：</span>
                <div class="con27"></div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit25">年營業額:NT</span>
                <div class="con28">
                  <span class="con28-1"></span>
                  <span class="txt">元</span>
                </div>
              </td>
            </tbody>
          </table>
          <!--table5-->
        </div>
        <!--area2-->
        <div class="area3">
          <table class="table6">
            <thead>
              <tr>
                <th colspan="4">
                  申請人基本資料(個人戶或公司負責人)
                  <div class="con29">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >負責人兼保證人
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="168px">
                  <span class="tdTit tdTit26">姓名：</span>
                  <div class="con30">{{editedItem.customer.name}}</div>
                </td>
                <td width="205px">
                  <span class="tdTit tdTit27">身分證字號：</span>
                  <div class="con31">{{editedItem.customer.memberId}}</div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit28">生日：</span>
                  <div class="con32">
                    <span class="con32-y">{{editedItem.customer.birthdayInfo.year}}</span>年
                    <span class="con32-m">{{editedItem.customer.birthdayInfo.month}}</span>月
                    <span class="con32-d">{{editedItem.customer.birthdayInfo.day}}</span>日
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit29">婚姻狀態：</span>
                  <div class="con33">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.married[0].value === true" disabled /></span
                    >已婚<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.married[1].value === true" disabled /></span
                    >未婚<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >其他
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table6-->
          <table class="table7">
            <tbody>
              <tr>
                <td width="305px">
                  <span class="tdTit tdTit30">學歷：</span>
                  <div class="con34">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.educationLevel[1].value === true" disabled /></span
                    >碩士以上<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.educationLevel[2].value === true" disabled /></span
                    >大學<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.educationLevel[3].value === true" disabled /></span
                    >專科<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.educationLevel[4].value === true" disabled /></span
                    >高中職<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.educationLevel[5].value === true" disabled /></span
                    >初中及以下
                  </div>
                </td>
                <td width="225px">
                  <span class="tdTit tdTit31">月收入：NT</span>
                  <div class="con35">
                    <span class="con35-1">{{editedItem.company.salary}}</span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit32">行業別：</span>
                  <div class="con36">{{editedItem.company.industry}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table8">
            <tbody>
              <tr>
                <td width="374px">
                  <span class="tdTit tdTit33">任職公司：</span>
                  <div class="con37">{{editedItem.company.name}}</div>
                </td>
                <td width="236px">
                  <span class="tdTit tdTit34">職稱：</span>
                  <div class="con38">{{editedItem.company.title}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit35">年資：</span>
                  <div class="con39">
                    <span class="con39-1">{{editedItem.company.workYear}}</span>
                    <span class="txt">年</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table8-->
          <table class="table9">
            <tbody>
              <tr>
                <td width="530px">
                  <span class="tdTit tdTit36">戶籍地址：</span>
                  <div class="con40">
                    <span class="con40-1"></span>
                    <span class="con40-1"></span>
                    <span class="con40-1"></span>
                  </div>
                  <div class="con41">
                    <!-- <span class="con41-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con41-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con41-address">樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span> -->
                    <span class="con41-address">{{editedItem.customer.home.residenceContent}}</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit37">戶籍電話：</span>
                  <div class="con42">{{editedItem.customer.phone}}</div>
                  <div class="con43 con43-1">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.liveLevel[0].value === true" disabled /></span
                    >自有<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.liveLevel[1].value === true" disabled /></span
                    >家人 <span class="con43-2"></span><br />
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.liveLevel[3].value === true" disabled /></span
                    >租賃，&nbsp;居住 <span class="con43-3">{{editedItem.customer.home.liveYear}}</span>年
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit38">通訊地址：</span>
                  <div class="con44">
                    <span class="con44-1"></span>
                    <span class="con44-1"></span>
                    <span class="con44-1"></span>
                  </div>
                  <div class="con45">
                    <!-- <span class="con45-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con45-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con45-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                    <span class="con45-address">{{editedItem.customer.home.homeContent}}</span>
                  </div>
                  <div class="con45-1">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.homeType1[0].value === true" disabled /></span
                    >同戶籍<br />
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >同公司
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit39">通訊電話：</span>
                  <div class="con46">{{editedItem.customer.homePhone}}</div>
                  <div class="con47 con47-1">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.liveLevel2[0].value === true" disabled /></span
                    >自有<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.liveLevel2[1].value === true" disabled /></span
                    >家人 <span class="con47-2"></span><br />
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.customer.home.liveLevel2[3].value === true" disabled /></span
                    >租賃，&nbsp;居住<span class="con47-3">{{editedItem.customer.home.liveYear2}}</span>年
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table9-->
          <table class="table10">
            <tbody>
              <tr>
                <td width="530px">
                  <span class="tdTit tdTit40">公司地址：</span>
                  <div class="con48">
                    <span class="con48-1"></span>
                    <span class="con48-1"></span>
                    <span class="con48-1"></span>
                  </div>
                  <div class="con49">
                    <!-- <span class="con49-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con49-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con49-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                    <span class="con49-address"
                      >{{editedItem.company.address}}</span
                    >
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit41">公司電話：</span>
                  <div class="con50">{{editedItem.company.phone}}</div>
                  <span class="tdTit tdTit42">分機</span>
                  <div class="con51">
                    <span class="con51-1"></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit43">E-mail：</span>
                  <div class="con52">
                    <span class="con52-1">{{editedItem.customer.email}}</span>
                    <span class="txt"
                      >(數字0請以<span class="icon"></span>書寫)</span
                    >
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit44">行動電話：</span>
                  <div class="con53">{{editedItem.customer.cellphone}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table10-->
          <table class="table11">
            <tr>
              <th rowspan="2" width="30px">
                <span class="tdTit tdTit45">繳款<br />方式</span>
              </th>
              <td>
                <div class="con55">
                  數位繳款
                  <div class="con55-1">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isAPPPay"></span>APP
                  </div>

                  <div class="con56">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isLINEPay"></span>LINE
                  </div>
                  <div class="con57">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isEmailPay"></span>Email
                  </div>
                  <div class="con58">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isSMSPay"></span>簡訊
                  </div>
                  <div class="con59">
                    (以上四者皆可至四大超商/ATM/網銀/銀行/郵局繳款)
                  </div>
                  <div class="con60">
                    自動扣款
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isAutoEDDAPay"></span>eDDA
                  </div>
                  <div class="con60-1">
                    <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isAutoBillPay"></span>ACH
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="con54">
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.paymentInfo.isBankPay"></span>支票繳款<span class="con54-0">(&nbsp;*&nbsp;請填寫</span>銀行
                  <span class="con54-1">{{ editedItem.paymentInfo.bankName }}</span>分行
                  <span class="con54-2">{{ editedItem.paymentInfo.bankSubName }}</span>戶名
                  <span class="con54-3">{{ editedItem.paymentInfo.accountName }}</span>帳號
                  <span class="con54-4">{{ editedItem.paymentInfo.bankAccountNo }}</span>)
                </div>
              </td>
            </tr>
          </table>
          <!--table11-->
          <table class="table12">
            <tr>
              <th width="30px">
                <span class="tdTit tdTit46">不動<br />產</span>
              </th>
              <td>
                <div class="con61">
                  地段<span class="con61-1"></span> 地號<span
                    class="con61-2"
                    ></span
                  >
                  建號<span class="con61-3"></span> 建物門牌<span
                    class="con61-4"
                    ></span
                  >所有權人：
                </div>
                <div class="con62">
                  <span class="checkbox"
                    ><input type="checkbox" disabled /></span
                  >車主<br />
                  <span class="checkbox"
                    ><input type="checkbox" disabled /></span
                  >保人
                  <span class="con62-1"></span>
                </div>
              </td>
            </tr>
          </table>
          <!--table12-->
        </div>
        <!--area3-->
        <div class="area4">
          <table class="table13">
            <thead>
              <tr>
                <th colspan="5">保證人一</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="170px">
                  <span class="tdTit tdTit47">姓名：</span>
                  <div class="con63">{{editedItem.jointGuarantor.name}}</div>
                </td>
                <td width="205px">
                  <span class="tdTit tdTit48">身分證字號：</span>
                  <div class="con64">{{editedItem.jointGuarantor.memberId}}</div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit49">生日：</span>
                  <div class="con65 con65-1">
                    <span class="con65-y">{{editedItem.jointGuarantor.birthdayInfo.year}}</span>年
                    <span class="con65-m">{{editedItem.jointGuarantor.birthdayInfo.month}}</span>月
                    <span class="con65-d">{{editedItem.jointGuarantor.birthdayInfo.day}}</span>日
                  </div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit50">婚姻狀態：</span>
                  <div class="con66">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >已婚<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >未婚<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >其他
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit51">關係：</span>
                  <div class="con67">{{editedItem.jointGuarantor.type}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table13-->
          <table class="table14">
            <tbody>
              <tr>
                <td width="305px">
                  <span class="tdTit tdTit52">學歷：</span>
                  <div class="con68">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >碩士以上<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >大學<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >專科<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >高中職<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >初中及以下
                  </div>
                </td>
                <td width="227px">
                  <span class="tdTit tdTit53">月收入：</span>
                  <div class="con69">
                    <span class="con69-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit54">行業別：</span>
                  <div class="con70"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table14-->
          <table class="table15">
            <tbody>
              <tr>
                <td width="374px">
                  <span class="tdTit tdTit55">任職公司：</span>
                  <div class="con71">{{editedItem.jointGuarantor.companyName}}</div>
                </td>
                <td width="236px">
                  <span class="tdTit tdTit56">職稱：</span>
                  <div class="con72">{{editedItem.jointGuarantor.title}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit57">年資：</span>
                  <div class="con73">
                    <span class="con73-1">{{editedItem.jointGuarantor.workYear}}</span>
                    <span class="txt">年</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table15-->
          <table class="table16">
            <tbody>
              <tr>
                <td width="532px">
                  <span class="tdTit tdTit58">戶籍地址：</span>
                  <div class="con74">
                    <span class="con74-1"></span>
                    <span class="con74-1"></span>
                    <span class="con74-1"></span>
                  </div>
                  <div class="con75">
                    <!-- <span class="con75-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con75-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con75-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                    <span class="con75-address"
                      >{{editedItem.jointGuarantor.home.residenceAddress}}</span
                    >
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit59">戶籍電話：</span>
                  <div class="con76">{{editedItem.jointGuarantor.phone}}</div>
                  <div class="con77">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[0].value" disabled /></span
                    >自有<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[1].value" disabled /></span
                    >家人 <span class="con77-1"></span><br />
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[3].value" disabled /></span
                    >租賃，&nbsp;居住 <span class="con77-2">{{editedItem.jointGuarantor.home.liveYear}}</span>年
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit60">通訊地址：</span>
                  <div class="con78">
                    <span class="con78-1"></span>
                    <span class="con78-1"></span>
                    <span class="con78-1"></span>
                  </div>
                  <div class="con79">
                    <!-- <span class="con79-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con79-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con79-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                    <span class="con79-address"
                      >{{editedItem.jointGuarantor.home.homeAddress1}}</span
                    >
                  </div>
                  <div class="con79-1">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.homeType1[0].value === true" disabled /></span
                    >同戶籍<br />
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >同公司
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit61">通訊電話：</span>
                  <div class="con80">{{editedItem.jointGuarantor.homePhone}}</div>
                  <div class="con81">
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[0].value" disabled /></span
                    >自有<span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[1].value" disabled /></span
                    >家人 <span class="con81-1"></span><br />
                    <span class="checkbox"
                      ><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[3].value" disabled /></span
                    >租賃，&nbsp;居住<span class="con81-2">{{editedItem.jointGuarantor.home.liveYear2}}</span>年
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table16-->
          <table class="table17">
            <tbody>
              <tr>
                <td width="532px">
                  <span class="tdTit tdTit62">公司地址：</span>
                  <div class="con82">
                    <span class="con82-1"></span>
                    <span class="con82-1"></span>
                    <span class="con82-1"></span>
                  </div>
                  <div class="con83 con83-0">
                    <!-- <span class="con83-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con83-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con83-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                    <span class="con83-address"
                      >{{editedItem.jointGuarantor.companyAddress}}</span
                    >
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit63">公司電話：</span>
                  <div class="con84">{{editedItem.jointGuarantor.companyPhone}}</div>
                  <span class="tdTit tdTit63-1">分機</span>
                  <div class="con84-1"></div>
                  <span class="tdTit tdTit64">行動電話：</span>
                  <div class="con85">{{editedItem.jointGuarantor.cellphone}}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table17-->
        </div>
        <!--area4-->
        <div class="area4">
          <table class="table13">
            <thead>
              <tr>
                <th colspan="5">保證人二</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="170px">
                  <span class="tdTit tdTit47">姓名：</span>
                  <div class="con63"></div>
                </td>
                <td width="205px">
                  <span class="tdTit tdTit48">身分證字號：</span>
                  <div class="con64"></div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit49">生日：</span>
                  <div class="con65">
                    <span class="con65-y"></span>年
                    <span class="con65-m"></span>月
                    <span class="con65-d"></span>日
                  </div>
                </td>
                <td width="157px">
                  <span class="tdTit tdTit50">婚姻狀態：</span>
                  <div class="con66">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >已婚<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >未婚<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >其他
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit51">關係：</span>
                  <div class="con67"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table13-->
          <table class="table14-2">
            <tbody>
              <tr>
                <td width="305px">
                  <span class="tdTit tdTit52-2">學歷：</span>
                  <div class="con68-2">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >碩士以上<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >大學<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >專科<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >高中職<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >初中及以下
                  </div>
                </td>
                <td width="227px">
                  <span class="tdTit tdTit53">月收入：NT</span>
                  <div class="con69">
                    <span class="con69-1"></span>
                    <span class="txt">元</span>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit54-2">行業別：</span>
                  <div class="con70"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table14-2-->
          <table class="table15-2">
            <tbody>
              <tr>
                <td width="374px">
                  <span class="tdTit tdTit55">任職公司：</span>
                  <div class="con71"></div>
                </td>
                <td width="236px">
                  <span class="tdTit tdTit56-2">職稱：</span>
                  <div class="con72"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit57-2">年資：</span>
                  <div class="con73-2">
                    <span class="con73-1"></span>
                    <span class="txt">年</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table15-2-->
          <table class="table16">
            <tbody>
              <tr>
                <td width="532px">
                  <span class="tdTit tdTit58">戶籍地址：</span>
                  <div class="con74">
                    <span class="con74-1"></span>
                    <span class="con74-1"></span>
                    <span class="con74-1"></span>
                  </div>
                  <div class="con75">
                    <!-- <span class="con75-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con75-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con75-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit59">戶籍電話：</span>
                  <div class="con76"></div>
                  <div class="con77">
                    <span class="checkbox"
                      ><input type="checkbox"  disabled /></span
                    >自有<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >家人<span class="con77-1"></span><br />
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >租賃，&nbsp;居住<span class="con77-2"></span>年
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit60">通訊地址：</span>
                  <div class="con78">
                    <span class="con78-1"></span>
                    <span class="con78-1"></span>
                    <span class="con78-1"></span>
                  </div>
                  <div class="con79">
                    <!-- <span class="con79-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con79-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con79-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                  </div>
                  <div class="con79-1">
                    <span class="checkbox"
                      ><input type="checkbox"  disabled /></span
                    >同戶籍<br />
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >同公司
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit61">通訊電話：</span>
                  <div class="con80"></div>
                  <div class="con81">
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >自有<span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >家人<span class="con81-1"></span><br />
                    <span class="checkbox"
                      ><input type="checkbox" disabled /></span
                    >租賃，&nbsp;居住<span class="con81-2"></span>年
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table16-->
          <table class="table17">
            <tbody>
              <tr>
                <td width="532px">
                  <span class="tdTit tdTit62">公司地址：</span>
                  <div class="con82">
                    <span class="con82-1"></span>
                    <span class="con82-1"></span>
                    <span class="con82-1"></span>
                  </div>
                  <div class="con83 con83-0">
                    <!-- <span class="con83-city">基隆</span>
                    <span class="city-1">縣</span>
                    <span class="city-2 choose">市</span>
                    <span class="con83-area">安樂安樂</span>
                    <span class="area-1">鄉</span>
                    <span class="area-2">鎮</span>
                    <span class="area-3">市</span>
                    <span class="area-4 choose">區</span>
                    <span class="con83-address"
                      >樂一里13鄰樂一路54巷4之1號基隆市安樂區樂一里13鄰樂一路54巷4之1號</span
                    > -->
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit63">公司電話：</span>
                  <div class="con84"></div>
                  <span class="tdTit tdTit63-1">分機</span>
                  <div class="con84-1"></div>
                  <span class="tdTit tdTit64">行動電話：</span>
                  <div class="con85"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--table17-->
        </div>
        <!--area4-->
        <div class="bottom">
          <ul>
            <li>
              1.本文件所提供之內容均為真實，並同意和潤企業為與申請事項有關之個人資料之搜集、利用及處理，如有不實，申請人等願付一切法律責任。
            </li>
            <li>2.本文件背面尚有個人資料運用告知同意書。</li>
            <li>3.<span>請翻至背面詳閱後簽名。</span></li>
          </ul>
          <div class="contact">
            <ul>
              <li>
                <div class="d1">聯絡人一：
                  <span class="con86">{{ editedItem.firstContact.name }}</span>
                </div>
                <div class="d2">關係：
                  <span class="con87">{{ editedItem.firstContact.type }}</span>
                </div>
                <div class="d3">手機：
                  <span class="con88">{{ editedItem.firstContact.cellphone }}</span>
                </div>
              </li>
              <li>
                <div class="d1">聯絡人二：
                  <span class="con86">{{ editedItem.secondContact.name }}</span>
                </div>
                <div class="d2">關係：
                  <span class="con87">{{ editedItem.secondContact.type }}</span>
                </div>
                <div class="d3">手機：
                  <span class="con88">{{ editedItem.secondContact.cellphone }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--bottom-->
        <div class="bt-left">FR-BA-062-005</div>
        <div class="bt-right">般1-11204</div>
      </div>
      <!--page1-->
      <div class="page page2">
        <h1>個人資料運用告知同意書<span></span></h1>
        <p class="p1">
          和潤企業股份有限公司（以下稱本公司）依據個人資料保護法（以下稱個資法）規定，向&nbsp;&nbsp;台端告知並說明下列事項，請&nbsp;&nbsp;&nbsp;&nbsp;台端詳閱：
        </p>
        <ul>
          <li>
            <span class="tit">一、</span
            >蒐集之目的：（一）辦理租賃、分期付款買賣、資金貸與、應收帳款受讓暨管理等相關業務（二）契約、類似契約或其他法律關係事務、核貸與授信業務、帳務管理及債權交易業務、債權整貼現及收買業務、徵信業務（含上下游及同業間彼此照會、租賃同業、關係企業、票信等照會之徵信行為）（三）調查、統計與研究分析：客戶管理、服務及消費者保護、其他經營合於營業登記項目或組織章程所定之業務（四）包括本公司、關係企業及相關業務委外機構等，於行銷或合作目的之範圍內使用。
          </li>
          <li>
            <span class="tit">二、</span
            >蒐集之個人資料類別：識別類（包括但不限姓名、出生年月日、國民身分證統一編號、護照號碼）、特徵類、家庭情形、社會情況、教育、考選、技術或其他專業、受僱情形、財務細節、商業資訊，含與本公司相關業務之申請書或契約書內容及其他具有正當合理關連之紀錄，但仍以本公司與&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;台端往來之相關業務所實際蒐集之個人資料為準。
          </li>
          <li>
            <span class="tit">三、</span>個人資料利用之期間、對象、地區及方式
            <ul class="ul2">
              <li>
                <span class="tit">（一）</span
                >期間：個人資料蒐集之特定目的存續期間、依相關法令或契約約定之保存期限（商業會計法等）或本公司因執行業務所必須之保存期間。
              </li>
              <li>
                <span class="tit">（二）</span
                >對象：本公司、本公司之關係企業暨其母&nbsp;(&nbsp;子&nbsp;)&nbsp;(&nbsp;孫&nbsp;)&nbsp;公司、通匯銀行、財團法人金融聯合徵信中心、票據交換所、財金資訊公司、中華徵信所股份有限公司及其關係企業與協力廠商、代理收付款項業務機構、業務委外機構、未受中央目的事業主管機關限制之國際傳輸個人資料之接收者、本公司之共同行銷、合作推廣對象或交互運用客戶資料公司、本公司所屬同業公會、其他與本公司有業務往來之機構、依法有調查權機關或金融監理機關。
              </li>
              <li>
                <span class="tit">（三）</span
                >地區：前揭利用對象之國內外營業所在地及未受中央目的事業主管機關限制之國際傳輸個人資料之接收者營業所在地。
              </li>
              <li>
                <span class="tit">（四）</span
                >方式：以自動化機器或其他非自動化方式之利用方式（例如使用電子文件、紙本或其他合於當時科技之適當方式）。
              </li>
            </ul>
          </li>
          <li>
            <span class="tit">四、</span
            >依據個資法第三條規定，台端就本公司保有&nbsp;&nbsp;&nbsp;&nbsp;台端之個人資料得行使下列權利：
            <ul class="ul2">
              <li>
                <span class="tit">（一）</span
                >得向本公司查詢、請求閱覽或請求製給複本，本公司依法得酌收必要成本費用。
              </li>
              <li>
                <span class="tit">（二）</span
                >得向本公司請求補充或更正，惟依法&nbsp;&nbsp;&nbsp;&nbsp;台端應為適當之釋明。
              </li>
              <li>
                <span class="tit">（三）</span
                >得向本公司請求停止蒐集、處理或利用及請求刪除，惟依法本公司依法執行業務所必須，得不依&nbsp;&nbsp;&nbsp;&nbsp;台端請求為之。惟&nbsp;&nbsp;&nbsp;&nbsp;台端若提出前述要求，應自行承擔因此所生之損失或損害，包括但不限於本公司可能無法提供或提前終止&nbsp;&nbsp;&nbsp;&nbsp;台端所需之商品及服務或有任何交易往來。
              </li>
            </ul>
          </li>
          <li>
            <span class="tit">五、</span
            >若於相關事實或法律關係存續期間或法令規定期間外，本公司所蒐集&nbsp;&nbsp;&nbsp;&nbsp;台端個人資料仍得為本公司、關係企業、合作廠商或主管機關核准經營業務之範圍，進行行銷活動或研究、統計之目的繼續使用。
          </li>
          <li>
            <span class="tit">六、</span
            >台端得自由選擇是否提供相關個人資料，惟若不簽署本同意書，本公司將可能無法與&nbsp;&nbsp;&nbsp;&nbsp;台端有任何往來或提供所需商品或服務，對&nbsp;&nbsp;&nbsp;&nbsp;台端所提供服務之範圍亦將會受到限制，包括優惠活動等。另依法，縱&nbsp;&nbsp;&nbsp;&nbsp;台端不簽署本同意書,，本公司仍有權基於法令及契約約定（含契約約定之服務、催收等）範圍內蒐集、處理及利用本人提供之個人資料。
          </li>
          <li>
            <span class="tit">七、</span>
            為響應節能減碳，本公司將推動發票無紙化，不再主動提供個人紙本電子發票證明聯，發票資訊可至本公司官 網查詢。若有紙本發票需求，請洽本公司客服人員。<br>本人同意此交易之發票由和潤企業將發票逕行上傳至和潤企業發票平台。
          </li>
        </ul>
        <p class="p2">
          立同意書人已清楚瞭解及知悉上開告知事項，並確實同意無誤。
        </p>
        <p class="p3">此致<span>和潤企業股份有限公司</span></p>
        <div class="box1">
          <p class="tit">
            立同意書人確認本文件所提供之內容均為真實，如有不實，願付一切法律責任。
          </p>
          <p>立同意書人(車主)：<span class="s1"></span>
          <img
              class="box"
              :src="signImageSrc('customer')"
            />
          </p>
          <v-layout>
            <v-flex md6>
              <p>立同意書人(連帶保證人一)：<span class="s2"></span>
                <img
                  class="box"
                  :src="signImageSrc('jointGuarantor')"
                />
              </p>
            </v-flex>
            <v-flex md6>
              <p>立同意書人(連帶保證人二)：<span class="s3"></span>
              </p>
            </v-flex>
          </v-layout>
          <div class="date">
            中華民國<span class="y"></span>年<span class="m"></span>月<span
              class="d"
              ></span
            >日
          </div>
        </div>
        <!--box1-->
        <div class="box2">
          <p>
            對保人茲證明立同意書人於本文件之簽章皆為真正無誤，如有不實，願負一切法律責任。
          </p>
          <div class="name">對保人：<span></span></div>
          <div class="date">對保日：<span></span></div>
        </div>
        <!--box2-->
        <div class="bt-left">FR-BA-062-005</div>
        <div class="bt-right">般1-11204</div>
      </div>
      <!--page2-->
    </div>
    <!--wrapper-->
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { sortApplicationItem } from "@/pages/utils/tool";
import download from "downloadjs";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";

export default {
  name: "loanhfcView",
  props: {
    item: Object,
  },
  data() {
    return {
      checkedImage: require("../../assets/images/checked.png"),
      createDate: "",
      itemInfo: null,
    };
  },
  created() {
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editedItem() {
      this.itemInfo = sortApplicationItem(this.item);
      return this.itemInfo;
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "customer") {
        if (this.editedItem.laonhfcInfo.signImage1) {
          source = this.editedItem.laonhfcInfo.signImage1;
        } else if (this.editedItem.signImage0) {
          source = this.editedItem.signImage0;
        } else if (this.editedItem.signImage0Url) {
          source = this.editedItem.signImage0Url;
        }
      } else if (itemPath === "jointGuarantor") {
        if (this.editedItem.laonhfcInfo.signImage2) {
          source = this.editedItem.laonhfcInfo.signImage2;
        } else if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signImage3Url) {
          source = this.editedItem.signImage3Url;
        }
      } else if (itemPath === "caseOfficer") {
        if (this.editedItem.laonhfcInfo.signImage3) {
          source = this.editedItem.laonhfcInfo.signImage3;
        } else if (this.editedItem.laonhfcInfo.signimage3Url) {
          source = this.editedItem.laonhfcInfo.signimage3Url;
        }
      }
      return source;
    },
  },
};
</script>

<style scoped src="../../assets/css/loanhfc_v202105_print.css">
</style>

<style scoped>
.box {
  position: absolute;
  width: 125px;
  height: 35px;
  bottom: 0px;
}
</style>

<style scoped>
.top-nb span,
.top-date span,
.con14,
.con22,
.con27,
.con30,
.con31,
.con36,
.con37,
.con38,
.con42,
.con46,
.con50,
.con53,
.con63,
.con64,
.con67,
.con70,
.con71,
.con72,
.con76,
.con80,
.con84,
.con84-1,
.con85 {
  color: #0505da;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/LoanhfcV202105View.vue